module.exports = __webpack_public_path__ + "img/accessory_shirt_07.0aeb7fc0.svg";